var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 100,
    viewBox: "0 0 75 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2982 90.4762C38.9147 90.4762 41.0358 92.6082 41.0358 95.2381C41.0358 97.868 38.9147 100 36.2982 100C33.6817 100 31.5606 97.868 31.5606 95.2381C31.5606 92.6082 33.6817 90.4762 36.2982 90.4762ZM59.3941 78.5714C62.9918 78.5714 65.9083 81.5029 65.9083 85.119C65.9083 88.7352 62.9918 91.6667 59.3941 91.6667C55.7964 91.6667 52.8798 88.7352 52.8798 85.119C52.8798 81.5029 55.7964 78.5714 59.3941 78.5714ZM41.0358 11.9048C59.3514 11.9048 74.1991 26.8286 74.1991 45.2381C74.1991 63.6476 59.3514 78.5714 41.0358 78.5714C40.6082 78.5714 40.1825 78.5633 39.7589 78.5472C37.5182 83.4778 32.5688 86.9048 26.823 86.9048C18.9735 86.9048 12.6102 80.5088 12.6102 72.619C12.6102 69.9645 13.3305 67.479 14.5854 65.3494C10.3726 59.7596 7.87256 52.7923 7.87256 45.2381C7.87256 26.8286 22.7203 11.9048 41.0358 11.9048ZM16.7556 0C19.045 0 20.901 1.86548 20.901 4.16667C20.901 6.46785 19.045 8.33333 16.7556 8.33333C14.4661 8.33333 12.6102 6.46785 12.6102 4.16667C12.6102 1.86548 14.4661 0 16.7556 0Z",
    fill: "#F46262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4439 78.5714C55.6048 78.5714 71.1378 63.0384 71.1378 43.8775C71.1378 24.7166 55.6048 9.18359 36.4439 9.18359C17.283 9.18359 1.75 24.7166 1.75 43.8775C1.75 63.0384 17.283 78.5714 36.4439 78.5714Z",
    stroke: "#29313A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4374 56.9295C51.6089 52.4932 44.334 49.8594 36.444 49.8594C28.275 49.8594 20.7655 52.6827 14.8379 57.4067",
    stroke: "#29313A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 100,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPopupIcon);
export default __webpack_public_path__ + "static/media/errorPopupIcon.286c08bd2125678d5ef315a330531a14.svg";
export { ForwardRef as ReactComponent };